<script>
import DataCard from "../../components/overview/DataCard.vue";
import { useUserStore } from "../../../stores/user";
import { useRoute } from "vue-router";

export default {
  components: { DataCard },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change-panel'],
  setup() {
    const userStore = useUserStore();
    const route = useRoute();
    return { userStore, route };
  },
  data() {
    return {
      householdName: null,
      householdRole: null,
      householdMemberCount: null,
      householdGiving: null
    };
  },
  computed: {
    organizationId() {
      return this.route.params.org;
    },
    canInvite() {
      return ["Head of Household", "Spouse"].includes(this.householdRole);
    },
    currentTab() {
      return this.route.params.panel;
    }
  },
  mounted() {
    this.loadHousehold();
  },
  methods: {
    loadHousehold() {
      const household = this.userStore.user?.household;
      if (household) {
        this.householdName = household.name;
        this.householdRole = household.role;
        this.householdMemberCount = household.member_count;

        // Fetch org-scoped giving total
        fetch(`/organizations/${this.organizationId}/households/${household.id}`, {
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
        }).then(res => res.json()).then(data => {
          if (data.total_giving !== undefined) this.householdGiving = data.total_giving;
        }).catch(() => {});
      }
    },
    changePanel(panel) {
      this.$emit('change-panel', panel);
    }
  }
};
</script>

<template>
  <data-card
    :loaded="!loading"
    title="My Household"
    title-class="text-lg font-semibold"
    additional-text="Your Household Information"
    additional-text-class="text-xs text-gray-500 font-normal"
    :left-sidebar="false"
    bordered
    border-class="border border-slate-200 rounded-lg shadow"
  >
    <div class="p-4 text-center">
      <p v-if="householdName" class="text-sm font-semibold text-gray-800 mb-2">{{ householdName }}</p>
      <p v-if="householdRole" class="text-sm text-gray-600 mb-1">Role: {{ householdRole }}</p>
      <p v-if="householdMemberCount" class="text-sm text-gray-600 mb-1">{{ householdMemberCount }} members</p>
      <p v-if="canInvite && householdGiving" class="text-sm text-green-600 font-semibold mb-3">${{ (householdGiving / 100).toLocaleString() }} this year</p>
      <button
        class="btn-brand cursor-pointer text-sm font-medium"
        :class="{ 'is-active': currentTab === 'household' }"
        @click="changePanel('household')"
      >
        View Details
      </button>
    </div>
  </data-card>
</template>

<style scoped lang="scss">
</style>
